<template>
  <el-tabs
    v-model="activeName"
    @tab-click="handleClick"
  >
    <el-tab-pane
      label="渠道列表"
      name="list"
    />
    <el-tab-pane
      label="数据统计"
      name="statistics"
    />
    <template v-if="activeName === 'list'">
      <SpFinder
        id="1"
        ref="finder"
        :show-tool-bar="false"
        :no-selection="true"
        class="channelCode"
        :url="{
          data: requestUrl + '/traffic/dynamic-code/list'
        }"
        title="数据"
        :columns="columns"
        :actions="actions"
      />
    </template>
    <template v-else>
      <Statistics :channel-data="channelData" />
    </template>
  </el-tabs>
</template>

<script>
import Statistics from './tmps/statistics'
export default {
  components: {
    Statistics
  },
  data () {
    const columns = [
      {
        name: '活码名称', // 表头
        key: 'channel_name' // 匹配data key
      },
      {
        name: '扫码次数', // 表头
        key: 'scan_code_num' // 匹配data key
      },
      {
        name: '添加时间', // 表头
        key: 'created_at', // 匹配data key
        width: 180
      },
      {
        name: '导购', // 表头
        key: 'salesperson_info', // 匹配data key
        width: 200,
        render: (h, { row }) => {
          let list = row.salesperson_info.slice(0, 1)
          if (list && list.length > 0) {
            return h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center'
                }
              },
              [
                h(
                  'ul',
                  list.map((item, index) => {
                    return h(
                      'span',
                      {
                        domProps: {
                          className: 'el-tag el-tag--info el-tag--light'
                        },
                        style: {
                          marginRight: '5px'
                        }
                      },
                      [
                        h('i', {
                          domProps: {
                            className: 'el-icon-user-solid'
                          },
                          style: {
                            color: '#409EFF',
                            marginRight: '2px'
                          }
                        }),
                        item
                      ]
                    )
                  })
                ),
                h('span', {}, row.salesperson_num > 1 ? '共' + row.salesperson_num + '人' : '')
              ]
            )
          } else {
            return null
          }
        }
      },
      {
        name: '渠道活码',
        key: 'work_wechat_qr_code',
        block: 'header', // 展示位置，header | footer
        width: 200,
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return (
            <div>
              <el-popover trigger='hover' placement='right' class='channel-list-first'>
                <div class='channelcode-hover-pic'>
                  <img class='hover-img' src={row.work_wechat_qr_code}></img>
                </div>
                <el-avatar
                  slot='reference'
                  nativeOnClick={(e) => this.handleTagClick(e, row)}
                  shape='square'
                  class='channel-list-code'
                  fit='fit'
                  src={`${row.work_wechat_qr_code}`}
                ></el-avatar>
              </el-popover>
            </div>
          )
        }
      }
    ]

    const actions = [
      {
        name: '新建活码',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'link',
          path: '/drainage/channelCode/0'
        }
      },
      {
        name: '编辑',
        key: 'edit',
        type: 'button',
        action: {
          type: 'link',
          path: (row, selections) => `/drainage/channelCode/${row.dynamic_code_id}` // 方法方式跳转
        }
      },
      {
        name: '查看数据',
        key: 'detail',
        type: 'button',
        action: {
          handler: (item) => {
            let row = item[0]
            this.activeName = 'statistics'
            this.channelData = row
          }
        }
      },
      {
        name: '活码下载',
        key: 'edit',
        type: 'button',
        action: {
          handler: (item) => {
            let row = item[0]
            this.downloadIamge(row.work_wechat_qr_code, row.channel_name + '.png')
          }
        }
      },
      {
        name: '删除',
        key: 'delete',
        type: 'button',
        action: {
          type: 'api',
          path: '/traffic/dynamic-code/delete?dynamic_code_id=${dynamic_code_id}', // api url
          onSuccess: () => {
            this.$refs.finder.refresh()
          },
          confirm: {
            message: '请确认是否删除？',
            title: '提示'
          }
        }
      }
    ]

    return {
      columns,
      actions,
      requestUrl: process.env.VUE_APP_BASE_API,
      activeName: 'list',
      channelData: {}
    }
  },

  methods: {
    handleTagClick (e, row) {
      const popoverEl = e.target.parentNode.parentNode
      setTimeout(() => {
        popoverEl.__vue__.showPopper = false
      }, 1000)
      console.info(row)
    },

    handleClick (tab) {
      this.activeName = tab.name
      this.channelData = {}
    },

    // 活码下载
    downloadIamge (imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc + '?time=' + Date.now()
    }
  }
}
</script>
<style lang="scss" scope>
.channelcode-hover-pic {
  .hover-img {
    display: block;
    width: 150px;
    height: 150px;
  }
}
.channel-list-first {
  .channel-list-code {
    width: 60px;
    height: 60px;
  }
}
</style>
